import * as React from 'react';

import {svgIconWrapper, type IconProps} from '../svg-icon-wrapper';

import SortAscendSvg from './sort-ascend.svg';
import SortDescendSvg from './sort-descend.svg';

interface SortIconProps extends IconProps {
    ascending?: boolean;
}

function SvgComponent(props: SortIconProps) {
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;
    delete validProps.ascending;

    if (props.ascending === true) {
        // @ts-expect-error
        return <SortAscendSvg {...validProps} />;
    }

    // @ts-expect-error
    return <SortDescendSvg {...validProps} />;
}
SvgComponent.iconName = 'sort';

export const SortIcon = svgIconWrapper(SvgComponent) as React.ComponentType<SortIconProps>;
